import { Box, Typography, type TypographyProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import { NavLink, type NavLinkProps } from "react-router";

export const Container = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "0.2rem",

  width: "100%",
  maxWidth: "100%",

  padding: theme.spacing(0.5, 0),

  textDecoration: "none",
  color: "inherit",

  borderRadius: theme.shape.borderRadius,
}));

export const OptionLink = styled(NavLink) <NavLinkProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;

  width: 100%;
`;

export const HighlightedText = styled("span")(({ theme }) => ({
  padding: "0 2px",

  fontWeight: 700,

  backgroundColor: theme.palette.yellow.main,
  borderRadius: 4,
}));

export const Title = styled(Typography)<TypographyProps>({
  minWidth: 0,
  whiteSpace: "normal",
  wordBreak: "break-word",
});

export const EventTitle = styled(Typography)<TypographyProps>(({ theme }) => ({
  minWidth: 0,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  color: theme.palette.text.secondary,
}));

export const Info = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5rem;

  width: 100%;
`;

export const VolLine = styled("span")({
  display: "inline-flex",
  alignItems: "baseline",
  gap: 4,
});

export const Chance = styled("span")`
  display: inline-flex;
  align-items: baseline;
  gap: 2px;
  flex-shrink: 0;
  margin-left: auto;
  white-space: nowrap;
`;
